(function(){
    'use strict';

    angular
    .module('app')
    .controller('EnlaceController', EnlaceController)
 
    EnlaceController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function EnlaceController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.datos = {};
        vm.datos.filas = [];
        
        vm.fieldName = ""

        vm.htmlDecode = function(input){
          var e = document.createElement('div');
          e.innerHTML = input;
          return e.childNodes[0].nodeValue;
        }

        vm.sortableOptions = {
            handle: '.movimientoac',
            placeholder:'app2',
            stop: function(e, ui) { 
            	//console.log("update");
            	vm.update();
            },
          }; 

        vm.initVars = function(fieldName,value){
            if(value!=""){
                value = vm.htmlDecode(value);
            }
            if(value!=""){
        	   value = JSON.stringify(value);
               value = value.replace(/\\n/g, "");
               value = value.replace(/\\r/g, "");
               value = value.replace(/\\t/g, "");
               value = value.replace(/([^>"]*)"(?=[^<]*>)/g, '$1\\\\"');
        	   value = JSON.parse(value);
        	   vm.datos = JSON.parse(value);
               //console.log(vm.datos);
            }
        	vm.fieldName = fieldName;
        }

        vm.addFila = function(){
            var datos = new Object();
            datos.titulo ="";
            datos.blank ="";
            datos.enlace ="";
            datos.icono ="";
            datos.page_id ="";
            vm.datos.filas.push(datos);     
            vm.update();      
            vm.edit(vm.datos.filas[vm.datos.filas.length-1]);
        }

        vm.borrarBloque = function(dato){
            var search = false;
            for(var cont=0;cont<vm.datos.filas.length && !search;cont++){
                if(vm.datos.filas[cont] == dato){
                    vm.datos.filas.splice(cont, 1);
                    search = true;
                }
            }
            vm.update();
        } 

        vm.update = function(){
			var json = angular.toJson(vm.datos);
			$timeout(function(){
				$('#'+vm.fieldName+"-jsonac").val(json).trigger("change");
			});
		}

        vm.modalContenido = "";
        vm.edit = function (dato) {
             vm.modalContenido = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'contenidoEnlace.html',
              size: 'lg',
              controller: function($scope) {
                $scope.titulo = dato.titulo;
                $scope.blank = dato.blank;
                $scope.enlace = dato.enlace;
                $scope.icono = dato.icono;
                $scope.page_id = dato.page_id;
                $scope.koForm = function(){
                    vm.modalContenido.close();
                }
                $scope.okForm = function(){
                    dato.titulo = $scope.titulo;
                    dato.blank = $scope.blank;
                    dato.enlace = $scope.enlace;
                    dato.icono = $scope.icono;
                    dato.page_id = $scope.page_id;
                    vm.update();
                    vm.modalContenido.close();
                }
              }
            });
        }

    } 

})();